import React from "react";
import { v4 as uuid } from "uuid";

import styles from "../../../../styles/payment-address.module.scss";

import { Drawer } from "../../../components/Drawer";
import { Button } from "../../../components/Button";

import { EnvironmentsAPI } from "../../../../providers/EnvironmentsAPI";
import { EnvironmentStorage } from "../../../tools/EnvironmentStorage";
import { Empty, Input, Label } from "@components";
import { Icon } from "shared/components/core/Icon";
import SearchAddresses from "shared/containers/SearchAddresses";

const Steps = {
  ADDRESSES: 0,
  SEARCH_ADDRESS: 1,
  CONFIRM_ADDRESS: 2,
};

const formattedAddress = (addressOptions) => {
  return `${addressOptions.region ? `${addressOptions.region},` : ","} ${
    addressOptions.city
  } -
      ${addressOptions.state}, ${addressOptions.country} ${
    addressOptions.zipcode ? `- ${addressOptions.zipcode}` : ""
  }`;
};

export default class PaymentAddressDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      step: Steps.ADDRESSES,
      loading: false,
      address: null,
      addresses: [],
    };
  }

  async componentDidMount() {
    const holdingId = await EnvironmentStorage.getEnvironmentHoldingId();
    const addresses = await EnvironmentsAPI.getConfigurationsByAlias(
      holdingId,
      "blocked_payment_address",
      []
    );

    this.setState({
      addresses,
    });
  }

  componentDidUpdate(prevProps, prevState) {}

  updateAddress(address) {
    const currentAddress = this.state.address;

    console.log("currentAddress", currentAddress);

    const updatedAddress = {
      ...currentAddress,
      ...address,
    };

    this.setState({
      address: updatedAddress,
    });
  }

  async addBlockedAddress() {
    const { address, addresses } = this.state;

    address.id = uuid();

    this.setState({
      loading: true,
    });

    const updateAddresses = [...addresses, address];

    const holdingId = await EnvironmentStorage.getEnvironmentHoldingId();
    const updateResponse = await EnvironmentsAPI.putConfigurationsByAlias(
      holdingId,
      "blocked_payment_address",
      { blocked_payment_address: updateAddresses }
    );

    if (updateResponse.getErrors([]).length > 0) {
      alert({ text: updateResponse.getErrors()[0], buttonText: "Ok" });
      this.setState({ loading: false });
      return false;
    } else {
      alert({ text: "Endereço bloqueado com sucesso", buttonText: "Ok" });
    }

    this.setState({
      loading: false,
      step: Steps.ADDRESSES,
      addresses: updateAddresses,
    });
  }

  async removeBlockedAddress(address) {
    this.setState({
      loading: true,
    });

    const holdingId = await EnvironmentStorage.getEnvironmentHoldingId();

    const addresses = await EnvironmentsAPI.getConfigurationsByAlias(
      holdingId,
      "blocked_payment_address",
      []
    );

    const updateAddresses = addresses.filter(
      (existingAddress) => existingAddress.id !== address.id
    );

    const updateResponse = await EnvironmentsAPI.putConfigurationsByAlias(
      holdingId,
      "blocked_payment_address",
      { blocked_payment_address: updateAddresses }
    );

    if (updateResponse.getErrors([]).length > 0) {
      alert({ text: updateResponse.getErrors()[0], buttonText: "Ok" });
      this.setState({ loading: false });
      return false;
    }

    this.setState({
      loading: false,
      addresses: updateAddresses,
    });
  }

  render() {
    const { visible, onClose } = this.props;
    const { step, addresses, address, loading } = this.state;

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        closeInFade
        showBackButton={step !== Steps.ADDRESSES}
        backButton={() => this.setState({ step: step - 1 })}
        title="Restrição de pagamento por endereço"
      >
        <div className={styles.paymentAddressContainer}>
          {step === Steps.ADDRESSES && (
            <>
              {addresses.length > 0 && (
                <Label className="mb-10">
                  Endereços bloqueados ({addresses.length})
                </Label>
              )}
              {addresses.map((address) => (
                <div className={styles.addressContainer}>
                  <div className={styles.addressDetails}>
                    <p className={styles.addressTitle}>
                      {address.address}, {address.number}
                    </p>
                    <span className={styles.addressDescription}>
                      {formattedAddress(address)}
                    </span>
                  </div>
                  <Button
                    design="default-icon-mini-2"
                    disabled={loading}
                    onClick={() => this.removeBlockedAddress(address)}
                  >
                    <Icon name="times" />
                  </Button>
                </div>
              ))}

              {addresses.length === 0 && (
                <Empty>
                  <Icon name="fa-map-marker-alt" size="2x" />
                  <p>Nenhum endereço bloqueado</p>
                  <span>
                    Por meio desta ferramenta, é possível bloquear o uso de
                    cartões para um endereço específico.
                  </span>
                </Empty>
              )}
            </>
          )}

          {step === Steps.SEARCH_ADDRESS && (
            <SearchAddresses
              onSelectAddress={(address) => {
                this.updateAddress(address);
              }}
            />
          )}

          {step === Steps.CONFIRM_ADDRESS && (
            <>
              <Input
                name="address"
                design="two"
                floatLabel="Logradouro"
                className="mb-20 mt-10"
                value={address?.address}
                onChange={(e) =>
                  this.updateAddress({ address: e.target.value })
                }
              />

              <Input
                name="number"
                design="two"
                floatLabel="Número"
                className="mb-20"
                value={address?.number}
                onChange={(e) => this.updateAddress({ number: e.target.value })}
              />

              <Input
                name="region"
                design="two"
                floatLabel="Bairro"
                className="mb-20"
                value={address?.region}
                onChange={(e) => this.updateAddress({ region: e.target.value })}
              />

              <Input
                name="city"
                design="two"
                floatLabel="Cidade"
                className="mb-20"
                value={address?.city}
                onChange={(e) => this.updateAddress({ city: e.target.value })}
              />

              <Input
                name="state"
                design="two"
                floatLabel="Estado"
                className="mb-20"
                value={address?.state}
                onChange={(e) => this.updateAddress({ state: e.target.value })}
              />
            </>
          )}

          <div className={styles.footer}>
            {step === Steps.ADDRESSES && (
              <Button
                className="w-100"
                design="primary"
                disabled={loading}
                onClick={() => this.setState({ step: Steps.SEARCH_ADDRESS })}
              >
                Adicionar endereço
              </Button>
            )}

            {step === Steps.SEARCH_ADDRESS && (
              <Button
                className="w-100"
                design="primary"
                onClick={() => this.setState({ step: Steps.CONFIRM_ADDRESS })}
                disabled={!address || !address.number}
              >
                Próximo
              </Button>
            )}

            {step === Steps.CONFIRM_ADDRESS && (
              <Button
                className="w-100"
                design="primary"
                disabled={loading}
                loading={loading}
                onClick={() => this.addBlockedAddress()}
              >
                Bloquear endereço
              </Button>
            )}
          </div>
        </div>
      </Drawer>
    );
  }
}
